import actionTypes from './actions/actionTypes';
const { REQUEST_SIGNUP, RECEIVE_SIGNUP_STATUS, AUTH_ERRORS } = actionTypes;

const signupReducer = (
  state = {
    isSigningIn: false,
    signupStatus: false,
    user: null,
    hasErrorOccured: false,
    errors: null
  },
  action
) => {
  switch (action.type) {
    case REQUEST_SIGNUP:
      return Object.assign({}, state, {
        isSigningIn: true,
        hasErrorOccured: false
      });
    case AUTH_ERRORS:
      return Object.assign({}, state, {
        hasErrorOccured: true,
        errors: action.errors
      });
    case RECEIVE_SIGNUP_STATUS:
      return Object.assign({}, state, {
        isSigningIn: false,
        signupStatus: action.success,
        user: action.user,
        hasErrorOccured: false
      });
    default:
      return state;
  }
};

export default signupReducer;


// WEBPACK FOOTER //
// src/routes/SignUp/reducer.js